import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { animate, style, transition, trigger } from "@angular/animations";
import { MenuService } from '../menu-service/menu.service';
import { Events } from "src/app/utils/event-utils";
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { SocketService } from 'src/app/services/app/socket-service/socket-service.service';
import { ToastrService } from 'ngx-toastr';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger("openCloseProfile", [
      transition(":enter", [
        style({ opacity: 0, transform: "scale(0.95)" }), //apply default styles before animation starts
        animate(
          "500ms ease-in-out",
          style({ opacity: 1, transform: "scale(1)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, }), //apply default styles before animation starts
        animate(
          "300ms ease-in-out",
          style({ opacity: 0, transform: "scale(.95)" })
        )
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('audioOption', { static: true }) audioPlayerRef!: ElementRef;
  subMenus: any;
  showUserOptions = false;
  currentPath = '';
  isHome = false;
  timeZone: any;
  showQuickMenu = false;
  user: any;
  intervalTimeID: any;
  currentTime = moment().toISOString();
  menus: any;
  isSound = true;
  userRole: any;
  showNotifications: boolean = false;
  unreadNotificationCount = 0;

  isDarkMode = false; // Default to light mode

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;

    if (this.isDarkMode) {
      document.documentElement.classList.add('dark'); // Use <html> element
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark'); // Use <html> element
      localStorage.setItem('theme', 'light');
    }
  }

  constructor(
    private sharedDataService: SharedDataService,
    private authService: AuthService,
    private menuService: MenuService,
    private socket: SocketService,
    private router: Router,
    private socketService: SocketService,
    // private dispatchCenterService: DispatchCenterService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      this.isDarkMode = true;
      document.documentElement.classList.add('dark'); // Use <html> element
    }
    this.getUser();
    this.router.events
    // .pipe(takeUntil(componentDestroyed(this)))
    .pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url) {
          let path = event.url;
          this.currentPath = path.substring(1);
          this.getSubMenus();
        }
      }
    });
    this.getSubMenus();

    // Setting the sound state if there is any value present in localstorage
    if (localStorage.getItem("sound")) {
      const sound = localStorage.getItem("sound");
      this.isSound = sound ? JSON.parse(sound) :  false;
    }
    
    this.listenSocket();
    this.listenNotifications();

    this.sharedDataService.getUnreadNotificationCount()
      .pipe(untilDestroyed(this))
      .subscribe(count => this.unreadNotificationCount = count);
    this.sharedDataService.refreshUnreadNotificationCount();
  }

  listenSocket() {
    this.socketService
      .addListener(Events.TRIP_NOTIFICATIONS)
      .pipe(untilDestroyed(this)).subscribe(data => {
        if (data) {
          this.toastr.success(data.message, 'Alert');
          this.onAudioPlay();
        }
      });
  }

  listenNotifications() {
    this.socketService
      .addListener(Events.NOTIFICATION)
      .pipe(untilDestroyed(this)).subscribe(data => {
        if (data) {
          if (data.type === 'error') {
            this.toastr.error(data.message, data.title);
          } else {
            this.toastr.info(data.message, data.title);
          }
          this.onAudioPlay();
          // the event is one new notification: count it locally instead of calling the server for every event
          this.sharedDataService.incrementUnreadNotificationCount();
        }
      });
  }

  onAudioPlay() {
    if (this.isSound) {
      this.audioPlayerRef.nativeElement.play();
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      // .pipe(takeUntil(componentDestroyed(this)))
      .pipe(untilDestroyed(this)).subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if(this.user.sRoles) {
              
                this.menus = this.menuService.getMenu(this.user.sRoles);
              } else {
          
                this.menus = this.menuService.getMenu(this.user.roles);
              }
            } else if ((typeof this.user.roles) === 'object') {
            
              this.menus = this.menuService.getMenu(this.user.roles[0]);
            }
          }
        }
      });
  }

  getSubMenus() {
    this.sharedDataService
      .getSubMenus()
      // .pipe(takeUntil(componentDestroyed(this)))
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        this.subMenus = [];
        if (data) {
          this.isHome = this.currentPath === data.key ? true : false;
          if (data.subMenus) {
            this.subMenus = data.subMenus;
          }
        }
      });
  }

  onQuickMenuClick(menuKey: any) {
    this.subMenus = [];
    const menu = this.menus[menuKey];
    this.sharedDataService.saveSubMenus(menu ? menu : null);

    // if (menu) {
    //   this.subMenus = menu.subMenus;
    // }
  }

  logout() {
    this.socket.disconnectSocket();
    this.authService.removeToken('access_token');
    this.authService.removeToken('refresh_token');
    this.sharedDataService.saveUser(null);
    this.router.navigateByUrl('login');
  }

  viewSmallScreenMenu() {
    this.sharedDataService.setSmallScreenMenuState(true);
  }

  onClickDropdownMenu() {
    this.sharedDataService.saveSubMenus(null);
    this.showUserOptions = !this.showUserOptions
  }

  toggleSound() {
    this.isSound = !this.isSound;
    localStorage.setItem("sound", JSON.stringify(this.isSound));
  }

  canViewSubmenu(subMenus: any, title: any) {
    let isFound = false;
    if (subMenus && subMenus.length) {
      isFound = subMenus.some((m: any) => m.title === title);
    }
    return isFound;
  }

  openNotificationModal(){
    this.showNotifications = !this.showNotifications;
  }
  closeActionMenu(evt:any) {
    this.showUserOptions = false;
  }

  ngOnDestroy(): void {
  }
}
